import { useAuth } from '@/hooks/useAuth';
import ToastUtils from '@/utils/toast-utils';
import React from 'react'

export default function SystemSettings(): React.JSX.Element {

  const { userLogout } = useAuth();

  const handleLogout = async (): Promise<void> => {
    ToastUtils.showLoading(true);
    await userLogout();
    ToastUtils.showLoading(false);
    
    // 导航到启动页
    window.location.href = '/';
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      {/* 消息自动翻译设置 */}
      <div className="bg-white rounded-lg p-6 mb-6 shadow-sm">
        <div className="space-y-4">
          {/* 第一个翻译设置 */}
          <div className="flex items-center justify-between py-3">
            <div>
              <h4 className="text-sm font-medium text-gray-900">消息自动翻译</h4>
            </div>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors">
              Setup
            </button>
          </div>

          {/* 分隔线 */}
          <div className="border-t border-gray-100"></div>

          {/* 第二个翻译设置 */}
          <div className="flex items-center justify-between py-3">
            <div>
              <h4 className="text-sm font-medium text-gray-900">消息自动翻译</h4>
            </div>
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 transition-colors">
              Setup
            </button>
          </div>
        </div>
      </div>

      {/* 退出登录 */}
      <div className="bg-white rounded-lg p-6 shadow-sm">
        <div className="flex items-center justify-center">
          <button
            onClick={handleLogout}
            className="px-8 py-2 text-sm font-medium text-red-600 hover:text-red-700 transition-colors"
          >
            退出登录
          </button>
        </div>
      </div>
    </div>
  )
}
